import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useBoundStore from 'store';
import { BuyApartmentFlowPaths } from '../../routes';
import useLimitsSecondary from '../../api/hooks/use-limits-secondary';
import { RUBLE_SIGN } from 'lib/constants';
import { formatViewObjectsPhrase } from 'lib/utils';
import { MarketTypes } from '../../api/types';
import PriceInput from 'components/price-input';
import { ButtonProps } from 'components/button';
import BaseScreen from 'components/base-screen';
import MeaningfulHeader from 'components/meaningful-header';
import styles from './styles.module.scss';

const ChoosePriceRangeSecondary: React.FC = () => {
  const navigate = useNavigate();
  const setPriceRangeMin = useBoundStore((s) => s.setPriceRangeMin);
  const priceRangeMin = useBoundStore((s) => s.priceRangeMin);
  const setPriceRangeMax = useBoundStore((s) => s.setPriceRangeMax);
  const priceRangeMax = useBoundStore((s) => s.priceRangeMax);
  const [lowerPrice, setLowerPrice] = useState<number | undefined>(priceRangeMin);
  const [upperPrice, setUpperPrice] = useState<number | undefined>(priceRangeMax);

  const { count, isLoading } = useLimitsSecondary(true, MarketTypes.SECONDARY);

  const setPriceForGlobalState = () => {
    lowerPrice && setPriceRangeMin(lowerPrice);
    upperPrice && setPriceRangeMax(upperPrice);
  };

  const buttons: ButtonProps[] = [
    {
      variant: 'gray',
      loading: isLoading,
      label: isLoading ? 'Загрузка' : formatViewObjectsPhrase(count),
      disabled: isLoading || count === undefined,
      onClick: () => {
        setPriceForGlobalState();
        navigate(BuyApartmentFlowPaths.apartmentListBuySecondary);
      },
    },
    {
      variant: 'secondary',
      label: 'Продолжить',
      onClick: () => {
        setPriceForGlobalState();
        navigate(BuyApartmentFlowPaths.chooseNumberOfRoomsSecondary);
      },
    },
  ];

  return (
    <BaseScreen
      padContent
      buttons={buttons}
      title='Подбор объектов вторички'
      onBackButtonClick={() => navigate(-1)}
    >
      <div className={styles.container}>
        <MeaningfulHeader
          className={styles.header}
          header={`Цена, ${RUBLE_SIGN}`}
          motto='Укажите диапазон цены'
        />

        <PriceInput
          clearButton
          value={lowerPrice}
          onChange={(value) => {
            setLowerPrice(Number(value));
            setPriceRangeMin(Number(value));
          }}
          autoFocus={lowerPrice === undefined}
          placeholder={'от'}
        />
        <PriceInput
          clearButton
          value={upperPrice}
          onChange={(value) => {
            setUpperPrice(Number(value));
            setPriceRangeMax(Number(value));
          }}
          placeholder={'до'}
        />
      </div>
    </BaseScreen>
  );
};

export default ChoosePriceRangeSecondary;
